import { creatorSection } from '@/mocks/home';

export default function CreatorSection() {
  return (
    <section id="creator" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            {creatorSection.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {creatorSection.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {creatorSection.benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center group hover:border-accent-300 transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-accent-500 transition-colors">
                <i className={`${benefit.icon} text-2xl text-accent-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all active:scale-95 whitespace-nowrap cursor-pointer">
            <i className="ri-user-add-line text-lg"></i>
            立即入驻成为创作者
          </button>
          <p className="mt-4 text-xs text-foreground-400">
            完成实名认证即可开通创作权限，新创作者享专属流量扶持
          </p>
        </div>
      </div>
    </section>
  );
}